import { shopManagerApi } from 'configs';
import api from 'configs/api';
import { toSnakeCase } from 'helpers/api';
import {
  getAutoQuotesStart,
  getAutoQuotesSuccess,
  getAutoQuotesFailed,
  getAutoQuotesCustomersStart,
  getAutoQuotesCustomersSuccess,
  getAutoQuotesCustomersFailed,
  downloadAutoQuotesCustomersStart,
  downloadAutoQuotesCustomersSuccess,
  downloadAutoQuotesCustomersFailed,
  createAutoQuoteStart,
  createAutoQuoteSuccess,
  createAutoQuoteFailed,
  getAutoQuotesSchedulesStart,
  getAutoQuotesSchedulesSuccess,
  getAutoQuotesSchedulesFailed,
  editAutoQuoteScheduleStart,
  editAutoQuoteScheduleSuccess,
  editAutoQuoteScheduleFailed,
  deleteAutoQuoteScheduleStart,
  deleteAutoQuoteScheduleSuccess,
  deleteAutoQuoteScheduleFailed,
} from 'redux/actions/automated_quotes';


export const getAutoQuotesApi = async ({
  dispatch,
  pageSize = 100,
  currentPage = 1
}) => {
  try {
    dispatch(getAutoQuotesStart());
    const { data } = await api.get(`${shopManagerApi}/auto-quotes/rules?pageSize=${pageSize}&currentPage=${currentPage}`);
    dispatch(getAutoQuotesSuccess(data));
  } catch (e) {
    dispatch(getAutoQuotesFailed(e));
  }
};

export const getAutoQuotesCustomersApi = async ({
  dispatch,
  id,
  sortDirection,
  sortField,
  pageSize = 10,
  currentPage = 1,
  filterConditions
}) => {
  try {
    dispatch(getAutoQuotesCustomersStart());
    const filterParams = new URLSearchParams(filterConditions).toString();
    const params = `pageSize=${pageSize}&currentPage=${currentPage}&sortField=${toSnakeCase(sortField)}&sortOrder=${sortDirection}${filterParams ? `&${filterParams}` : ''}`;
    const { data } = await api.get(`${shopManagerApi}/auto-quotes/${id}/results?${params}`);
    dispatch(getAutoQuotesCustomersSuccess(data));
  } catch (e) {
    dispatch(getAutoQuotesCustomersFailed(e));
  }
};

export const downloadAutoQuotesCustomersApi = async ({ dispatch, id }) => {
  try {
    dispatch(downloadAutoQuotesCustomersStart());

    const {data} = await api({
      method: 'get',
      url: `${shopManagerApi}/auto-quotes/${id}/download-report`,
      responseType: 'blob'
    });

    const file = URL.createObjectURL(data);
    window.location.assign(file);

    dispatch(downloadAutoQuotesCustomersSuccess(data));
  } catch (e) {
    dispatch(downloadAutoQuotesCustomersFailed(e));
  }
};

export const createAutoQuoteApi = async ({ dispatch, automatedQuote }) => {
  try {
    dispatch(createAutoQuoteStart());
    const { data } = await api.post(`${shopManagerApi}/auto-quotes/schedule`, automatedQuote);
    dispatch(createAutoQuoteSuccess(data));
    return data;
  } catch (e) {
    dispatch(createAutoQuoteFailed(e));
    return null;
  }
};

export const getAutoQuotesSchedulesApi = async ({ dispatch }) => {
  try {
    dispatch(getAutoQuotesSchedulesStart());
    const { data } = await api.get(`${shopManagerApi}/auto-quotes/schedules`);
    dispatch(getAutoQuotesSchedulesSuccess(data));
    return data;
  } catch (e) {
    dispatch(getAutoQuotesSchedulesFailed(e));
    return null;
  }
};

export const editAutoQuoteScheduleApi = async ({ dispatch, schedule }) => {
  try {
    dispatch(editAutoQuoteScheduleStart());
    const { data } = await api.patch(`${shopManagerApi}/auto-quotes/schedule/${schedule._id}`, schedule);
    console.log('data: ', data);
    dispatch(editAutoQuoteScheduleSuccess(data));
  } catch (e) {
    dispatch(editAutoQuoteScheduleFailed(e));
  }
};

export const deleteAutoQuoteScheduleApi = async ({ dispatch, id }) => {
  try {
    dispatch(deleteAutoQuoteScheduleStart());
    const { data } = await api.delete(`${shopManagerApi}/auto-quotes/schedule/${id}`);
    dispatch(deleteAutoQuoteScheduleSuccess(data, id));
  } catch (e) {
    dispatch(deleteAutoQuoteScheduleFailed(e));
  }
};
